import {
    useEffect,
    useState
} from "react";

import {
    useNavigate,
    useParams
} from "react-router-dom";

import Select from "react-select";
import API from "../../services/api";
import toast from "react-hot-toast";

function InvoiceForm() {

    const navigate = useNavigate();

    const { id } = useParams();

    const [customers, setCustomers] = useState([]);

    const [products, setProducts] = useState([]);
    const [wallets, setWallets] = useState([]);

    const loadInvoice = async () => {

        const res =
            await API.get(
                `/invoices/${id}/edit`
            );

        setForm({

            customer_id:
                res.data.invoice.customer_id,

            invoice_no:
                res.data.invoice.invoice_no,

            invoice_date:
    new Date(res.data.invoice.invoice_date)
        .toISOString()
        .split("T")[0],

            discount:
                res.data.invoice.discount,

            discount_type:
                res.data.invoice.discount_type,

            cash_amount:
                res.data.invoice.cash_amount,

            bank_amount:
                res.data.invoice.bank_amount

        });

        setCustomers(
            res.data.customers
        );

        setProducts(
            res.data.products
        );

        setItems(
            res.data.items
        );

    };

    const [form, setForm] = useState({
        customer_id: "",
        invoice_no: `INV-${Date.now()}`,
        invoice_date: new Date().toISOString().split("T")[0],

        discount_type: "amount",
        discount: 0,
        cash_amount: 0,
        bank_amount: 0
    });

    const [items,
        setItems] =
        useState([
            {
                product_id: "",
                qty: 1,
                selling_price: 0,
                gst_percent: 0
            }
        ]);

    useEffect(() => {

        loadData();

        if (id) {
            loadInvoice();
        }

    }, [id]);

    const loadData =
        async () => {

            try {

                const customerRes =
                    await API.get(
                        "/customers"
                    );

                const productRes =
                    await API.get(
                        "/products"
                    );

                setCustomers(
                    customerRes.data.customers || []
                );

                setProducts(
                    productRes.data.products || []
                );

                const walletRes = await API.get("/wallets");
                setWallets(
                    walletRes.data.wallets || []
                );

            } catch (err) {
                console.log(err);
            }

        };

    const handleProductChange =
        (
            index,
            selected
        ) => {

            const product =
                products.find(
                    p =>
                        p.id ===
                        selected.value
                );

            const updated =
                [...items];

            updated[index] = {
                ...updated[index],
                product_id:
                    product.id,
                selling_price:
                    product.selling_price,
                gst_percent:
                    product.gst_percent
            };

            setItems(updated);

        };

    const handleItemChange =
        (
            index,
            field,
            value
        ) => {

            const updated =
                [...items];

            updated[index][field] =
                value;

            setItems(updated);

        };

    const addRow =
        () => {

            setItems([
                ...items,
                {
                    product_id: "",
                    qty: 1,
                    selling_price: 0,
                    gst_percent: 0
                }
            ]);

        };

    const removeRow =
        (index) => {

            if (
                items.length === 1
            ) return;

            setItems(
                items.filter(
                    (_, i) =>
                        i !== index
                )
            );

        };

    const subtotal =
        items.reduce(
            (
                sum,
                item
            ) =>
                sum +
                (
                    Number(item.qty) *
                    Number(item.selling_price)
                ),
            0
        );

    const gstTotal =
        items.reduce(
            (
                sum,
                item
            ) => {

                const amount =
                    Number(item.qty) *
                    Number(
                        item.selling_price
                    );

                return (
                    sum +
                    (
                        amount *
                        Number(
                            item.gst_percent
                        ) / 100
                    )
                );

            },
            0
        );

    const totalBeforeDiscount = subtotal + gstTotal;

    const discountAmount = form.discount_type === "percent"
        ? totalBeforeDiscount * Number(form.discount) / 100
        : Number(form.discount);

    const grandTotal = totalBeforeDiscount - discountAmount;
    const paidAmount = Number(form.cash_amount) + Number(form.bank_amount);
    const remainingAmount = grandTotal - paidAmount;

    const submit = async (e) => {

        e.preventDefault();

        try {

            let res;

            if (id) {

                res = await API.put(
                    `/invoices/${id}/edit`,
                    {
                        ...form,
                        items
                    }
                );

            } else {

                res = await API.post(
                    "/invoices",
                    {
                        ...form,
                        items
                    }
                );

            }

            toast.success(
                res.data.message
            );

            navigate("/admin/invoices");

        } catch (err) {

            console.log(err);

            toast.error(
                err.response?.data?.message ||
                "Something went wrong."
            );

        }

    };

    return (
        <div>

            <h1
                className="
        text-3xl
        font-bold
        mb-6
        "
            >
                {id ? "Edit Invoice" : "Create Invoice"}
            </h1>

            <form
                onSubmit={submit}
                className="
        bg-[#111]
        rounded-2xl
        p-6
        "
            >

                {/* TOP */}

                <div
                    className="
          grid
          md:grid-cols-3
          gap-4
          mb-8
          "
                >

                    <select
                        value={
                            form.customer_id
                        }
                        onChange={(e) =>
                            setForm({
                                ...form,
                                customer_id:
                                    e.target.value
                            })
                        }
                        className="
            p-3
            bg-black
            rounded-xl
            "
                        required
                    >
                        <option value="">
                            Select Customer
                        </option>

                        {customers.map(
                            (
                                customer
                            ) => (
                                <option
                                    key={
                                        customer.id
                                    }
                                    value={
                                        customer.id
                                    }
                                >
                                    {
                                        customer.customer_name
                                    }
                                </option>
                            )
                        )}

                    </select>

                    <input
                        type="text"
                        value={
                            form.invoice_no
                        }
                        onChange={(e) =>
                            setForm({
                                ...form,
                                invoice_no:
                                    e.target.value
                            })
                        }
                        className="
            p-3
            bg-black
            rounded-xl
            "
                    />

                    <input
                        type="date"
                        value={
                            form.invoice_date
                        }
                        onChange={(e) =>
                            setForm({
                                ...form,
                                invoice_date:
                                    e.target.value
                            })
                        }
                        className="
            p-3
            bg-black
            rounded-xl
            "
                    />


                </div>

                <div className="grid md:grid-cols-2 gap-4 my-6">

                    <div>

                        <label className="block mb-2">
                            Cash Amount
                        </label>

                        <input
                            type="number"
                            value={form.cash_amount}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    cash_amount: e.target.value
                                })
                            }
                            className="w-full p-3 bg-[#111] rounded-xl border border-yellow-500/20"
                        />

                    </div>

                    <div>

                        <label className="block mb-2">
                            Bank Amount
                        </label>

                        <input
                            type="number"
                            value={form.bank_amount}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    bank_amount: e.target.value
                                })
                            }
                            className="w-full p-3 bg-[#111] rounded-xl border border-yellow-500/20"
                        />

                    </div>

                </div>

                {/* ITEMS */}

                <div className="overflow-x-auto">

                    <table className="w-full">

                        <thead>

                            <tr
                                className="
                border-b
                border-yellow-500/20
                "
                            >

                                <th className="p-3 text-left">
                                    Product
                                </th>

                                <th className="p-3">
                                    Qty
                                </th>

                                <th className="p-3">
                                    Price
                                </th>

                                <th className="p-3">
                                    GST %
                                </th>

                                <th className="p-3">
                                    Amount
                                </th>

                                <th className="p-3">
                                    Action
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {items.map(
                                (
                                    item,
                                    index
                                ) => (

                                    <tr
                                        key={index}
                                        className="
                    border-b
                    border-yellow-500/10
                    "
                                    >

                                        <td className="p-2 min-w-[300px]">
                                            <Select
                                                placeholder="Search Product..."
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        backgroundColor: "#000",
                                                        border: "1px solid rgba(234,179,8,.2)",
                                                        minHeight: "48px",
                                                        boxShadow: "none"
                                                    }),

                                                    singleValue: (base) => ({
                                                        ...base,
                                                        color: "#fff"
                                                    }),

                                                    input: (base) => ({
                                                        ...base,
                                                        color: "#fff"
                                                    }),

                                                    placeholder: (base) => ({
                                                        ...base,
                                                        color: "#9ca3af"
                                                    }),

                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 99999
                                                    }),

                                                    menu: (base) => ({
                                                        ...base,
                                                        backgroundColor: "#111",
                                                        border: "1px solid rgba(234,179,8,.2)"
                                                    }),

                                                    option: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: state.isFocused
                                                            ? "#eab308"
                                                            : "#111",
                                                        color: state.isFocused
                                                            ? "#000"
                                                            : "#fff",
                                                        cursor: "pointer"
                                                    })
                                                }}
                                                options={products.map((product) => ({
                                                    value: product.id,
                                                    label: `${product.name} (Stock: ${product.stock})`
                                                }))}
                                                value={
                                                    products
                                                        .filter(
                                                            p => p.id == item.product_id
                                                        )
                                                        .map(
                                                            p => ({
                                                                value: p.id,
                                                                label: `${p.name} (Stock: ${p.stock})`
                                                            })
                                                        )[0]
                                                }
                                                onChange={(selected) =>
                                                    handleProductChange(
                                                        index,
                                                        selected
                                                    )
                                                }
                                            />

                                        </td>

                                        <td className="p-2">

                                            <input
                                                type="number"
                                                min="1"
                                                value={
                                                    item.qty
                                                }
                                                onChange={(e) =>
                                                    handleItemChange(
                                                        index,
                                                        "qty",
                                                        e.target.value
                                                    )
                                                }
                                                className="
                        w-24
                        p-3
                        bg-black
                        rounded-xl
                        "
                                            />

                                        </td>

                                        <td className="p-2">

                                            <input
                                                type="number"
                                                value={
                                                    item.selling_price
                                                }
                                                onChange={(e) =>
                                                    handleItemChange(
                                                        index,
                                                        "selling_price",
                                                        e.target.value
                                                    )
                                                }
                                                className="
                        w-32
                        p-3
                        bg-black
                        rounded-xl
                        "
                                            />

                                        </td>

                                        <td className="p-2">

                                            <input
                                                type="number"
                                                value={
                                                    item.gst_percent
                                                }
                                                onChange={(e) =>
                                                    handleItemChange(
                                                        index,
                                                        "gst_percent",
                                                        e.target.value
                                                    )
                                                }
                                                className="
                        w-24
                        p-3
                        bg-black
                        rounded-xl
                        "
                                            />

                                        </td>

                                        <td
                                            className="
                      p-2
                      text-yellow-400
                      font-semibold
                      "
                                        >
                                            ₹
                                            {(
                                                Number(
                                                    item.qty
                                                ) *
                                                Number(
                                                    item.selling_price
                                                )
                                            ).toFixed(2)}
                                        </td>

                                        <td className="p-2">

                                            <button
                                                type="button"
                                                onClick={() =>
                                                    removeRow(
                                                        index
                                                    )
                                                }
                                                className="
                        bg-red-500
                        px-4
                        py-2
                        rounded-xl
                        "
                                            >
                                                Delete
                                            </button>

                                        </td>

                                    </tr>

                                )
                            )}

                        </tbody>

                    </table>

                </div>

                {/* TOTALS */}

                <div
                    className="
          flex
          justify-end
          mt-8
          "
                >

                    <div
                        className="
            w-full
            md:w-96
            bg-black
            border
            border-yellow-500/20
            rounded-2xl
            p-5
            "
                    >

                        <div className="flex justify-between">
                            <span>
                                Subtotal
                            </span>

                            <span>
                                ₹
                                {subtotal.toFixed(
                                    2
                                )}
                            </span>
                        </div>

                        <div className="flex justify-between mt-3">
                            <span>
                                GST
                            </span>

                            <span>
                                ₹
                                {gstTotal.toFixed(
                                    2
                                )}
                            </span>
                        </div>

                        <div className="mt-5">

                            <label className="block mb-2">
                                Discount
                            </label>

                            <div className="flex gap-3">

                                <select
                                    value={form.discount_type}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            discount_type: e.target.value
                                        })
                                    }
                                    className="
                                    p-3 
                                    bg-black 
                                    rounded-xl
                                    border
                                    border-yellow-500/20
                                    "
                                >

                                    <option value="amount">
                                        ₹ Amount
                                    </option>

                                    <option value="percent">
                                        %
                                    </option>

                                </select>

                                <input
                                    type="number"
                                    value={form.discount}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            discount: e.target.value
                                        })
                                    }
                                    className="
                                    flex-1 
                                    p-3 
                                    bg-black 
                                    rounded-xl
                                    border
                                    border-yellow-500/20"
                                />

                            </div>

                        </div>


                        <div
                            className="
              flex
              justify-between
              mt-4
              pt-4
              border-t
              border-yellow-500/20
              text-2xl
              font-bold
              text-yellow-400
              "
                        >

                            <span>
                                Grand Total
                            </span>

                            <span>
                                ₹
                                {grandTotal.toFixed(
                                    2
                                )}
                            </span>

                        </div>

                        <div className="mt-6">

                            <label className="block mb-2 font-semibold">
                                Paid Amount
                            </label>

                            <div className="w-full p-3 bg-[#111] rounded-xl border border-yellow-500/20 font-bold text-green-400">

                                ₹ {paidAmount.toFixed(2)}

                            </div>

                        </div>

                        <div className="flex justify-between mt-4">

                            <span>
                                Remaining
                            </span>

                            <span className="text-red-400 font-bold">

                                ₹ {remainingAmount.toFixed(2)}

                            </span>

                        </div>

                        <div className="flex justify-between mt-2">

                            <span>
                                Payment Status
                            </span>

                            <span
                                className={
                                    paidAmount >= grandTotal
                                        ? "text-green-400"
                                        : paidAmount > 0
                                            ? "text-yellow-400"
                                            : "text-red-400"
                                }
                            >
                                {
                                    paidAmount >= grandTotal
                                        ? "Paid"
                                        : paidAmount > 0
                                            ? "Partial"
                                            : "Pending"
                                }
                            </span>

                        </div>

                    </div>

                </div>

                {/* BUTTONS */}

                <div
                    className="
          flex
          gap-3
          mt-6
          flex-wrap
          "
                >

                    <button
                        type="button"
                        onClick={addRow}
                        className="
            bg-blue-500
            px-5
            py-3
            rounded-xl
            "
                    >
                        + Add Product
                    </button>

                    <button
                        type="submit"
                        className="
            bg-yellow-500
            text-black
            px-6
            py-3
            rounded-xl
            font-semibold
            "
                    >
                        {id ? "Update Invoice" : "Save Invoice"}
                    </button>

                </div>

            </form>

        </div>
    );
}

export default InvoiceForm;